import { Tooltip } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Tier } from "components/Admin/Organizations/types/Tier.type";
import React from "react";
import { OrganizationServiceHierarchyStore } from "../stores/OrganizationServiceHierarchyStore";
import theme from "Theme/AppTheme";

interface AddRowIconProps {
    tier: Tier;
    osmStore: OrganizationServiceHierarchyStore;
    isLeaf?: boolean;
}

type Props = AddRowIconProps;

const AddRowIcon: React.FC<
    React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({ tier, isLeaf, osmStore }) => {
    const enableAddition = (tier): boolean => {
        if (tier.branchDepth === osmStore.orgServiceSetup?.length - 1) {
            return false;
        }

        return true;
    };

    const handleOnClick = () => {
        osmStore.setActiveTier(tier);
        osmStore.setShowAddTierDialog(true);
    };

    return enableAddition(tier) ? (
        <Tooltip title={"Add Tier"}>
            <AddCircleIcon
                color="primary"
                onClick={handleOnClick}
                cursor="pointer"
                sx={{
                    display: "flex",
                    alignItems: "center",
                    marginRight: theme.spacing(1),
                    marginLeft: theme.spacing(1),
                    cursor: "pointer",
                }}
            />
        </Tooltip>
    ) : (
        <Tooltip
            title={
                "No more tiers are available in this organization service hierarchy."
            }
        >
            <AddCircleIcon
                htmlColor="#d5dff6"
                sx={{
                    display: "flex",
                    alignItems: "center",
                    marginRight: theme.spacing(1),
                    marginLeft: theme.spacing(1),
                    cursor: "pointer",
                }}
            />
        </Tooltip>
    );
};

export default AddRowIcon;
